export const DUET_HINGE_ASSETS = {
  'silver-plated-tabletop-frame-small-5x7': {
    url: 'https://cdn.shopify.com/s/files/1/0769/3602/0283/files/Metal_Duet_Frames_5x7_Silver-Hinge.jpg?v=1791984381',
    overlapInInches: 0.20
  },
  'brass-tabletop-frame-small-5x7': {
    url: 'https://cdn.shopify.com/s/files/1/0769/3602/0283/files/Metal_Duet_Frames_5x7_Gold-Hinge.jpg?v=1791985523',
    overlapInInches: 0.20
  },
  'leather-duet-frame-5x7': {
    url: 'https://cdn.shopify.com/s/files/1/0769/3602/0283/files/Leather_Duet_Frame_5x7-Hinge.jpg?v=1792065391',
    overlapInInches: 0.03
  }
};

export const isDuetFrameSpec = (frameSpec) => {
  const permalink = frameSpec?.moulding?.permalink;

  return Boolean(permalink && DUET_HINGE_ASSETS[permalink]);
};
